import { render, staticRenderFns } from "./ContainerBloc.vue?vue&type=template&id=20c552e8&"
import script from "./ContainerBloc.vue?vue&type=script&lang=js&"
export * from "./ContainerBloc.vue?vue&type=script&lang=js&"
import style0 from "./ContainerBloc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports